import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RenderOptions } from "../../charts/charts.model";

@Component({
  selector: "app-rendering-options",
  templateUrl: "./rendering-options.component.html",
  styleUrls: ["./rendering-options.component.scss"],
  standalone: false,
})
export class RenderingOptionsComponent {
  @Input() render: RenderOptions;
  @Input() markLinesAndScale: boolean = false;
  @Input() coOccurPercentageOption: boolean = false;
  @Output() setRenderOptions = new EventEmitter<RenderOptions>();

  setRender() {
    this.setRenderOptions.emit(this.render);
  }
}
